import type { MdArtifactStatusInEnvironment } from '../graphql/graphql-sdk';

export const OVERVIEW_VERSION_STATUSES: MdArtifactStatusInEnvironment[] = [
  'PENDING',
  'APPROVED',
  'DEPLOYING',
  'CURRENT',
];
